"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getXsrfCookieName = exports.XSRF_HEADER = void 0;
/* istanbul ignore file */
// This is necessary because when requests are performed from the browser
// the XSRF cookie is read into a XSRF header which is a core aspect
// of Xsrf protection
// TODO consider instead exposing browser side getXsrfCookie that
// reads the browser cookie and returns a tuple with the name of
// header and the value
// How this works? The browser field in package.json not only allows you
// to change your module entry point, but to also replace or ignore individual
// files within your module. More info:
// https://docs.npmjs.com/cli/v6/configuring-npm/package-json#browser
var constants_1 = require("./constants");
Object.defineProperty(exports, "XSRF_HEADER", { enumerable: true, get: function () { return constants_1.XSRF_HEADER; } });
var cookie_1 = require("./cookie");
Object.defineProperty(exports, "getXsrfCookieName", { enumerable: true, get: function () { return cookie_1.getXsrfCookieName; } });
